import { Box, Card, CardContent, CardMedia, styled, Typography } from "@mui/material"
import { Link } from "react-router-dom"

const StyeledCard = styled(Box)((theme) => ({
        minWidth: '10em',
    width: '10em',
    maxWidth: '192px',
    height: '300px',
    borderRadius: '10px',
    background:'#fff',
    textDecoration:'none'
}))

const ProductCard = (props) => {

    return (
        <Link to={"/product/"+ props?.cardUrl} style={{textDecoration:'none',color:'black'}}>
       
        <StyeledCard  >
            <CardMedia component={"img"} height={200} image={props?.cardImage} alt={props?.cardText} sx={{ objectFit: 'contain' }} />
            <Box sx={{display:'flex',flexDirection:'column',paddingLeft:'10px'}}>
                <Typography variant="h6" fontSize={'0.8rem'} fontWeight={"bold"} gutterBottom>{props?.cardText}</Typography>
            </Box>
            
        </StyeledCard>
        </Link>
    )

}

export default ProductCard